export const grass = {
  name: 'Grass',
  color: [0.51, 0.18, 0.07, 1],
  bg: [0.23, 0.45, 0.26, 1],
  grid1: [0.98, 0.94, 0.68, 1],
  grid2: [0.93, 0.7, 0.32, 0.5],
}
